.input {
  composes: text from '../text/Text.css';
  font-size: 1rem;
  padding: 0.4rem 0.8rem;
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  background-color: inherit;
  width: 100%;
}

.input:focus {
  outline: 0;
  border: 1px solid var(--ib-red);
}

.disabledInput {
  composes: input;
  cursor: not-allowed;
}

.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  /* width: 19rem; */
}

.disabledWrapper {
  background-color: #ebebeb;
}

.inrText {
  margin: 0 0 0 1rem;
  z-index: 1;
}

.inrInput {
  border: none;
  margin-left: -1.65rem;
}

.number {
  composes: number from '../text/Text.css';
}

::placeholder {
  color: #aeaeae;
}

.label {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0;
  padding-bottom: 0;
  position: absolute;
  left: 1rem;
  top: 0.4rem;
  transition: top 50ms, left 50ms;
  background-color: inherit;
  pointer-events: none;
}

.input:focus + .label,
.input:valid + .label {
  top: -1.1rem;
  font-size: 0.7rem;
  left: -0.1rem;
}
